export const generateTimeout = (tries = 1, lastTimeout) => {
  if (tries === 1 || !lastTimeout) {
    return Math.floor(Math.random() * 50 + 50);
  }

  return lastTimeout * 2;
};
